<template>
  <div class="text-with-emoji">
    <validation-observer
      ref="form"
    >
      <div
        v-if="showNameButton"
        class="d-flex mb-1 justify-content-end"
      >
        <b-button
          :title="getReplyTrans('first_name')"
          variant="secondary"
          size="sm"
          @click="insertNameSymbol()"
        >
          <i class="fa fa-user" />
          {{ getReplyTrans('insert-commenter-name') }}
        </b-button>
      </div>
      <div class="position-relative">
        <ok-text-input
          ref="message"
          v-model="message"
          :rules="rules"
          :show-counter="true"
          :rows="5"
          :style-obj="messageStyle"
          :placeholder="placeholder || getReplyTrans('text_message_hint')"
          :label="$t('general.message-content')"
          textarea
          @click="showEmoji=false"
        />
        <p
          v-if="showMax"
          class="float-right"
          style="margin-top: 5px"
        >
          {{ message.length +'/'+max }}
        </p>
        <picker
          v-show="showEmoji"
          color="#367fa9"
          :show-preview="false"
          :data="index1"
          @select="addEmoji"
        />
        <a
          ref="emoji"
          href="#"
          @click.prevent="showEmoji=!showEmoji"
        ><FeatherIcon
          size="20"
          icon="SmileIcon"
        /></a>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import data from 'emoji-mart-vue-fast/data/facebook.json'
import { Picker, EmojiIndex } from 'emoji-mart-vue-fast'
import 'emoji-mart-vue-fast/css/emoji-mart.css'
import { ValidationObserver } from 'vee-validate'
import { BButton } from 'bootstrap-vue'
import '@core/utils/validations/validations'
import OkTextInput from '@/@bya3/components/inputs/OkTextInput'

const index1 = new EmojiIndex(data)

export default {
  name: 'EmojiMessageTemplate',
  components: {
    Picker,
    ValidationObserver,
    BButton,
    OkTextInput,
  },
  props: {
    showMax: {
      type: Boolean,
      default: false,
    },
    showNameButton: {
      type: Boolean,
      default: true,
    },
    max: {
      type: Number,
      default: 1200,
    },
    rules: {
      type: String,
      default: 'required',
    },
    placeholder: {
      type: String,
      default: '',
    },
    componentMessage: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showEmoji: false,
      index1,
      messageHeight: '400',
      message: '',
    }
  },
  computed: {
    messageStyle() {
      return {
        'min-height': this.messageHeight,
      }
    },
  },
  watch: {
    message() {
      this.resize()
      this.$emit('input', this.message)
    },
  },
  mounted() {
    this.message = this.componentMessage
  },
  methods: {
    getReplyTrans(string) {
      return this.$t(`reply.form.${string}`)
    },
    resize() {
      this.messageHeight = `${this.$refs.message.$refs.input.scrollHeight}px`
    },
    addEmoji(emoji) {
      const ele = this.$refs.message.$refs.input
      const startPos = ele.selectionStart
      const endPos = ele.selectionEnd
      const tmpStr = ele.value
      this.message = tmpStr.substring(0, startPos) + emoji.native + tmpStr.substring(endPos, tmpStr.length)
    },
    insertNameSymbol() {
      const name = this.$store.getters['auth/isInstagram'] ? '#NAME#' : ' #FIRST_NAME# #LAST_NAME# '
      const ele = this.$refs.message.$refs.input
      const startPos = ele.selectionStart
      const endPos = ele.selectionEnd
      const tmpStr = ele.value
      this.message = `${tmpStr.substring(0, startPos)} ${name} ${tmpStr.substring(endPos, tmpStr.length)}`
    },
  },
}

</script>
<style scoped>
  .text-with-emoji a {
    top: 35px;
    z-index: 3;
  }
</style>
